import store from '@/store'
import { convAOSLang } from '@/utils/i18n'

export function gotoAOSForm (d) {
  let lang = convAOSLang(store.getters.language)
  if (lang) {
    lang = lang.toLowerCase()
    window.open(
      `/merchant-onboarding/${lang}/${d.bid}/${d.brand_id}`,
      '_self'
    )
  }
}

export function updateRoute (field, v) {
  var query = JSON.parse(JSON.stringify(this.$route.query))
  var fields = Array.isArray(field) ? field : [{
    'field': field,
    'value': v
  }]
  for (var idx in fields) {
    var f = fields[idx]
    if (f.value !== '' && f.value !== null) {
      query[f.field] = f.value
    } else {
      delete query[f.field]
    }
  }
  query['page'] = 1
  this.$router.push({ query: query })
}

export function pushRoute (field, v) {
  var query = JSON.parse(JSON.stringify(this.$route.query))
  query[field] = v
  if (field !== 'page') {
    query['page'] = 1
  }
  this.$router.push({ query: query })
}

export function gotoOrdersList (ordersID) {
  if (!ordersID) {
    this.$alert({
      message: this.$t('api.orders.name'),
      type: 'warning'
    })
  }
  this.$router.push({
    path: '/orders/orders/list?id=' + ordersID + '&date_range=all'
  })
}
